

// import React, { useCallback, useContext, useEffect, useState } from 'react';
// import { FaSearch, FaShoppingCart, FaUser } from 'react-icons/fa';
// import logo from './logo1.jpeg';
// import Glow from './glowcart.png';
// import { CartContext } from '../Cart/CartContext';
// import { WishlistContext } from '../Wishlist/WishlistContext';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { useParams } from 'react-router-dom';
// import A1 from './google.png'
// import A2 from './appstore.png'
// import { useRef } from 'react';
// import { FaCaretDown } from "react-icons/fa";
// import { IoMdArrowDropright } from "react-icons/io";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

// const Header = () => {

//     const [showLoginModal, setShowLoginModal] = useState(false);
//     const { cartItems } = useContext(CartContext);
//     const { wishlistItems } = useContext(WishlistContext);
//     const [categoriesp, setCategoriesp] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);
//     const [hoveredCategory, setHoveredCategory] = useState(null);
//     const { categoryName } = useParams();
//     const [hoveredSubcat, setHoveredSubcat] = useState(null);

//     // Fetch categories and subcategories safely
//     useEffect(() => {
//         fetch('https://api.glocart.in/pages/api/api/categories')
//             .then(res => res.json())
//             .then(data => {
//                 // Ensure we only store an array
//                 const categoriesArray = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
//                 setCategoriesp(categoriesArray);
//             })
//             .catch(err => console.error('Error fetching categories:', err));

//         fetch('https://api.glocart.in/pages/api/api/subcategories')
//             .then(res => res.json())
//             .then(data => {
//                 const subcatsArray = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
//                 setSubcategories(subcatsArray);
//             })
//             .catch(err => console.error('Error fetching subcategories:', err));
//     }, []);

//     // Group categories by super_cat_id safely
//     const groupedCategories = Array.isArray(categoriesp)
//         ? Object.values(
//             categoriesp.reduce((acc, item) => {
//                 if (!acc[item.super_cat_id]) {
//                     acc[item.super_cat_id] = {
//                         super_cat_id: item.super_cat_id,
//                         super_cat_name: item.super_cat_name,
//                         subs: [],
//                     };
//                 }
//                 acc[item.super_cat_id].subs.push(item);
//                 return acc;
//             }, {})
//         )
//         : [];

//     // Get subcategories for a specific category safely
//     const getSubcategoriesForCategory = (category_id, super_cat_id) => {
//         return Array.isArray(subcategories)
//             ? subcategories.filter(
//                 sub =>
//                     sub.category_id === String(category_id) &&
//                     sub.super_cat_id === String(super_cat_id)
//             )
//             : [];
//     };













//     const getCartItemCount = () => cartItems.reduce((total, item) => total + item.quantity, 0);


//     const [products, setProducts] = useState([]);
//     const [showSuggestions, setShowSuggestions] = useState(false);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [suggestions, setSuggestions] = useState([]);
//     const wrapperRef = useRef(null);
//     useEffect(() => {
//         axios.get('https://api.glocart.in/pages/api/products/get')
//             .then(res => {
//                 const data = res.data;
//                 // adjust depending on API shape
//                 const list = Array.isArray(data) ? data : (data.products || []);
//                 setProducts(list);
//             })
//             .catch(err => console.error('Error fetching products for search:', err));
//     }, []);
//     const onChangeSearch = (e) => {
//         const val = e.target.value;
//         setSearchQuery(val);

//         if (val.length > 0) {
//             const filtered = products.filter(prod =>
//                 prod.name.toLowerCase().includes(val.toLowerCase()) ||
//                 prod.category.toLowerCase().includes(val.toLowerCase()) ||
//                 (prod.subcategory && prod.subcategory.toLowerCase().includes(val.toLowerCase()))
//             );
//             setSuggestions(filtered.slice(0, 5));
//             setShowSuggestions(true);
//         } else {
//             setSuggestions([]);
//             setShowSuggestions(false);
//         }
//     };

//     const onSuggestionClick = (prod) => {
//         // You may navigate to product page or set input value
//         navigate(`/product/${prod.id}`);
//         setSearchQuery('');  // clear or set as needed
//         setShowSuggestions(false);
//     };

//     // Close suggestions when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//                 setShowSuggestions(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);














//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     useEffect(() => {
//         const storedUserData = sessionStorage.getItem('userData');
//         const storedUserId = sessionStorage.getItem('userId');
//         if (storedUserData) {
//             setIsLoggedIn(true);
//         } else if (storedUserId) {
//             resumeRegistration(storedUserId);
//         }
//     }, []);

//     const resumeRegistration = async (id) => {
//         try {
//             const res = await axios.get(`https://api.glocart.in/auth/api/api/user/${id}/details`);
//             const user = res.data.user;
//             setUserId(user.id);

//             if (!user.email || !user.addresses || user.addresses.length === 0) {
//                 setShowLoginModal(true);
//                 if (!user.email) {
//                     setStep('userinfo');
//                 } else {
//                     setEmail(user.email);
//                     setStep('address');
//                 }
//             } else {
//                 const loginData = {
//                     id: user.id,
//                     email: user.email,
//                     business_type: user.business_type
//                 };
//                 sessionStorage.setItem('userData', JSON.stringify(loginData));
//                 setIsLoggedIn(true);

//                 // ✅ Sync tempCart to DB if exists
//                 const tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
//                 if (tempCart.length > 0) {
//                     for (const item of tempCart) {
//                         await axios.post('https://api.glocart.in/pages/api/api/add-to-cart', {
//                             userId: loginData.id,
//                             productId: item.productId,
//                             variantId: item.variantId,
//                             quantity: item.quantity,
//                             customerType: item.type || (loginData.business_type === 'B2B' ? 'B2B' : 'B2C'),
//                         });
//                     }
//                     sessionStorage.removeItem('tempCart');
//                 }
//             }
//         } catch (err) {
//             console.error('Failed to resume user registration', err);
//         }
//     };

//     const [userId, setUserId] = useState(null);
//     const [step, setStep] = useState('login');
//     const [mobileNumber, setMobileNumber] = useState('');
//     const [otp, setOtp] = useState(['', '', '', '', '', '']);
//     const [timer, setTimer] = useState(30);
//     const [firstName, setFirstName] = useState('');
//     const [lastName, setLastName] = useState('');
//     const [email, setEmail] = useState('');
//     const [businessType, setBusinessType] = useState('');
//     const [address, setAddress] = useState({ line1: '', line2: '', city: '', state: '', zip: '', });
//     const resetForm = () => {
//         setStep('login');
//         setMobileNumber('');
//         setOtp(['', '', '', '', '', '']);
//         setFirstName('');
//         setLastName('');
//         setEmail('');
//         setAddress({ line1: '', line2: '', city: '', state: '', zip: '', });
//         setUserId(null);
//     };

//     useEffect(() => {
//         if (step === 'otp' && timer > 0) {
//             const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
//             return () => clearInterval(interval);
//         }
//     }, [step, timer]);

//     const sendOtp = async () => {
//         try {
//             await axios.post('https://api.glocart.in/auth/api/api/send-otp', { contact: mobileNumber });
//             setStep('otp'); setTimer(30);
//         } catch (error) {
//             console.error(error);
//             alert(error.response?.data?.error || 'Failed to send OTP');
//         }
//     };

//     // 2. Verify OTP
//     const verifyOtp = async () => {
//         try {
//             const enteredOtp = otp.join('');
//             const res = await axios.post('https://api.glocart.in/auth/api/api/verify-otp', {
//                 contact: mobileNumber,
//                 otp: enteredOtp
//             });
//             if (res.data.success) {
//                 const userId = res.data.userId;
//                 setUserId(userId);
//                 sessionStorage.setItem('userId', userId);
//                 const userRes = await axios.get(`https://api.glocart.in/auth/api/api/user/${userId}/details`);
//                 const user = userRes.data.user;
//                 if (user.email && user.addresses && user.addresses.length > 0) {
//                     const loginData = {
//                         id: user.id,
//                         email: user.email,
//                         business_type: user.business_type
//                     };
//                     sessionStorage.setItem('userData', JSON.stringify(loginData));

//                     const tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
//                     console.log(tempCart)
//                     for (const item of tempCart) {
//                         console.log(item)
//                         await axios.post('https://api.glocart.in/pages/api/api/add-to-cart', {
//                             userId: loginData.id,
//                             productId: item.productId,
//                             variantId: item.variantId,
//                             quantity: item.quantity,
//                             customerType: item.type || (userId?.businessType === 'B2B' ? 'B2B' : 'B2C'),
//                         });
//                     };
//                     // sessionStorage.removeItem('tempCart');
//                     setIsLoggedIn(true);
//                     setShowLoginModal(false);
//                     resetForm();
//                     navigate('/cart');
//                 } else {
//                     setStep('userinfo');
//                 }
//             } else {
//                 alert(res.data.error || 'Invalid or expired OTP');
//             }
//         } catch (error) {
//             console.error(error);
//             alert('OTP verification failed');
//         }
//     };


//     // 3. Update user info
//     const updateUserInfo = async () => {
//         try {
//             await axios.post('https://api.glocart.in/auth/api/api/update-user', { userId, first_name: firstName, last_name: lastName, email, business_type: businessType, });
//             const loginData = {
//                 id: userId,
//                 email,
//                 business_type: businessType
//             };
//             sessionStorage.setItem('userData', JSON.stringify(loginData));

//             setStep('address');
//         } catch (err) {
//             console.error(err); alert('Failed to update user');
//         }
//     };



//     // 4. Save address
//     const saveAddress = async () => {
//         try {
//             await axios.post('https://api.glocart.in/auth/api/api/save-address', {
//                 userId,
//                 address
//             });

//             const loginData = JSON.parse(sessionStorage.getItem('userData'));

//             // ✅ Sync tempCart to DB after full registration
//             const tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
//             for (const item of tempCart) {
//                 await axios.post('https://api.glocart.in/pages/api/api/add-to-cart', {
//                     userId: loginData.id,
//                     productId: item.productId,
//                     variantId: item.variantId,
//                     quantity: item.quantity,
//                     customerType: item.type || (loginData.business_type === 'B2B' ? 'B2B' : 'B2C'),
//                 });
//             }

//             // ✅ Now remove tempCart and proceed
//             sessionStorage.removeItem('tempCart');
//             alert('Account created!');
//             setIsLoggedIn(true);
//             setShowLoginModal(false);
//             resetForm();
//             if (tempCart.length > 0) {
//                 navigate('/cart');
//             } else {
//                 navigate('/');
//             }
//         } catch (err) {
//             console.error(err);
//             alert('Failed to save address');
//         }
//     };



//     const logout = () => {
//         sessionStorage.removeItem('userData');
//         sessionStorage.removeItem('userId');
//         setIsLoggedIn(false);
//         resetForm();
//         setShowUserMenu(false);
//         console.log("Logged out, session data cleared");
//     };

//     const [showUserMenu, setShowUserMenu] = useState(false);
//     const toggleUserMenu = () => { setShowUserMenu(prev => !prev); };
//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (!e.target.closest('.user-menu-container')) {
//                 setShowUserMenu(false);
//             }
//         };
//         document.addEventListener('click', handleClickOutside);
//         return () => document.removeEventListener('click', handleClickOutside);
//     }, []);



//     const navigate = useNavigate();
//     const handleCartClick = () => {
//         if (isLoggedIn) {
//             navigate('/cart');
//         } else {
//             setShowLoginModal(true);
//         }
//     };




//     const [isSmallScreen, setIsSmallScreen] = useState(false);
//     useEffect(() => {
//         const handleResize = () => {
//             setIsSmallScreen(window.innerWidth < 768);
//         };
//         handleResize();
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);















//     const [userLocation, setUserLocation] = useState(null);
//     const [showLocationModal, setShowLocationModal] = useState(false);
//     const [markerPosition, setMarkerPosition] = useState({
//         lat: 28.6139, 
//         lng: 77.2090,
//     });
//     const { isLoaded } = useJsApiLoader({
//         googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
//     });
//     const handleLocationClick = () => setShowLocationModal(true);
//     const onMarkerDragEnd = useCallback((e) => {
//         const lat = e.latLng.lat();
//         const lng = e.latLng.lng();
//         setMarkerPosition({ lat, lng });
//         reverseGeocode(lat, lng);
//     }, []);
//     const reverseGeocode = async (lat, lng) => {
//         try {
//             const API_KEY = "AIzaSyAskOLVxenXFbWP4Z-kTOJnzaC-p7a5fBM";
//             const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
//             );
//             const data = await res.json();
//             if (data.results[0]) {
//                 setUserLocation(data.results[0].formatted_address);
//             }
//         } catch (err) {
//             console.error("Geocoding error:", err);
//         }
//     };
//     const getCurrentLocation = () => {
//         if (!navigator.geolocation) return alert("Geolocation not supported");
//         navigator.geolocation.getCurrentPosition((pos) => {
//             const { latitude, longitude } = pos.coords;
//             setMarkerPosition({ lat: latitude, lng: longitude });
//             reverseGeocode(latitude, longitude);
//         });
//     };
//     const truncateAddress = (address) =>
//         address.length > 40 ? address.slice(0, 40) + "..." : address;






//     return (
//         <>
//             {/* Top Header */}
//             <div className='mt-1' style={{ display: 'flex', alignItems: 'center', padding: '10px 20px', background: '#fffff', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', justifyContent: 'space-between', flexWrap: 'wrap', maxWidth: '1200px', margin: '0 auto', borderRadius: "5px" }}>
//                 <div>
//                     {!isSmallScreen && (<img src={logo} alt="BigBasket Logo" style={{ height: '60px', borderRadius: '10px', display: 'inline-block' }} />)}
//                     {isSmallScreen && (<img src={Glow} alt="BigBasket Glow Logo" style={{ height: '60px', borderRadius: '10px', display: 'inline-block' }} />)}
//                 </div>

//                 <div style={{ position: 'relative', flex: 1, margin: '0 20px', maxWidth: '600px' }} ref={wrapperRef}>
//                     <FaSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#999' }} />
//                     <div ref={wrapperRef} style={{ position: 'relative' }}>
//                         <input type="text" value={searchQuery} onChange={onChangeSearch} placeholder="Search for Products..." style={{ width: '100%', padding: '10px 14px 10px 32px', border: '1px solid #ccc', borderRadius: '25px', fontSize: '14px', outline: 'none' }} />
//                         {showSuggestions && suggestions.length > 0 && (
//                             <ul style={{ position: 'absolute', top: '40px', left: 0, width: '100%', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', listStyle: 'none', padding: '8px 0', margin: 0, zIndex: 1000 }}>
//                                 {suggestions.map((s, i) => (
//                                     <li key={i} onClick={() => onSuggestionClick(s)} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #eee' }}>
//                                         {s.name}
//                                     </li>
//                                 ))}
//                             </ul>
//                         )}
//                     </div>
//                 </div>


//                 <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//                     {!isSmallScreen && (
//                         <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
//                             <div onClick={handleLocationClick} style={{ display: "flex", alignItems: "center", cursor: "pointer", padding: "6px 16px", borderRadius: "6px", backgroundColor: "#f6f6f6", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", transition: "background 0.3s ease", width: "fit-content", }}>
//                                 <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="#FF3C3C" style={{ marginRight: "8px" }}>
//                                     <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
//                                 </svg>
//                                 <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.2" }}>
//                                     <span style={{ fontSize: "14px", color: "#555", fontWeight: "500" }}>Deliver to</span>
//                                     <span style={{ fontSize: "10px", fontWeight: "600", color: "#000" }}>
//                                         {userLocation ? truncateAddress(userLocation) : "Select Location"}
//                                     </span>
//                                 </div>
//                             </div>
//                             {showLocationModal && (
//                                 <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000, }}>
//                                     <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", width: "90%", maxWidth: "600px", textAlign: "center", }}>
//                                         <h3 style={{ marginBottom: "12px" }}>Select Delivery Location</h3>
//                                         {isLoaded ? (
//                                             <GoogleMap center={markerPosition} zoom={14} mapContainerStyle={{ width: "100%", height: "400px", borderRadius: "10px", }} onClick={(e) => setMarkerPosition({ lat: e.latLng.lat(), lng: e.latLng.lng(), })}>
//                                                 <Marker position={markerPosition} draggable onDragEnd={onMarkerDragEnd} />
//                                             </GoogleMap>
//                                         ) : (
//                                             <p>..</p>
//                                         )}
//                                         <div style={{ marginTop: "15px" }}>
//                                             <button onClick={getCurrentLocation} style={{ padding: "8px 16px", background: "#FF3C3C", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", marginRight: "8px", }}>Use My Location</button>
//                                             <button onClick={() => setShowLocationModal(false)} style={{ padding: "8px 16px", background: "#ccc", border: "none", borderRadius: "5px", cursor: "pointer", }}>Confirm</button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}


//                     {isLoggedIn ? (
//                         <div className="user-menu-container" style={{ position: 'relative' }}>
//                             <FaUser onClick={toggleUserMenu} style={{ fontSize: '22px', color: '#000', cursor: 'pointer' }} />

//                             {showUserMenu && (
//                                 <div style={{ position: 'absolute', top: '35px', right: 0, background: '#1c1c1c', color: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.2)', width: '280px', zIndex: 1000, padding: '10px 0', }}>
//                                     <div style={{ padding: '10px 16px', cursor: 'pointer' }}>
//                                         <Link to="/account" style={{ color: 'inherit', textDecoration: 'none' }}>My Account</Link>
//                                     </div>
//                                     <div style={{ padding: '10px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                         <Link to="/cart" style={{ color: 'inherit', textDecoration: 'none', flex: 1 }}>My Basket</Link>
//                                         <span style={{ backgroundColor: 'red', borderRadius: '12px', padding: '2px 8px', fontSize: '12px' }}>{getCartItemCount()}</span>
//                                     </div>
//                                     <div style={{ padding: '10px 16px', cursor: 'pointer' }}>
//                                         <Link to="/orders" style={{ color: 'inherit', textDecoration: 'none' }}>My Orders</Link>
//                                     </div>
//                                     <div style={{ padding: '10px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                         <Link to="/wishlist" style={{ color: 'inherit', textDecoration: 'none' }}>Wishlist</Link>
//                                         <span style={{ backgroundColor: 'red', borderRadius: '12px', padding: '2px 8px', fontSize: '12px' }}>{wishlistItems.length}</span>
//                                     </div>
//                                     <div style={{ padding: '10px 16px', cursor: 'pointer' }}>
//                                         <Link to="/contact-us" style={{ color: 'inherit', textDecoration: 'none' }}>Contact Us</Link>
//                                     </div>
//                                     <div style={{ padding: '10px 16px', cursor: 'pointer', color: '#ff5252' }} onClick={logout}>
//                                         Logout
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     ) : (
//                         <button style={{ background: '#0057A0', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '4px', fontSize: '14px', cursor: 'pointer', marginLeft: '10px' }} onClick={() => setShowLoginModal(true)}>
//                             Login / Sign Up
//                         </button>
//                     )}

//                     <div onClick={handleCartClick} style={{ position: 'relative', marginLeft: '10px', cursor: 'pointer' }}>
//                         <FaShoppingCart style={{ fontSize: '20px', color: '#0057A0' }} />
//                         <span style={{ position: 'absolute', top: '-6px', right: '-10px', background: 'red', color: 'white', fontSize: '11px', padding: '2px 6px', borderRadius: '50%' }}>
//                             {getCartItemCount()}
//                         </span>
//                     </div>
//                 </div>
//             </div>




//             <div style={{ display: 'flex', alignItems: 'center', gap: '20px', padding: '12px 20px', background: '#FFFFFF', borderTop: '1px solid #eee', borderBottom: '1px solid #eee', flexWrap: 'wrap', maxWidth: '1200px', margin: '0 auto', }}>
//                 <a href="/" style={{ textDecoration: 'none' }}>
//                     <button style={{ background: '#0057A0', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '10px', fontSize: '14px', cursor: 'pointer', }}>
//                         Shop by <strong>CATEGORY</strong>
//                     </button>
//                 </a>

//                 <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
//                     {groupedCategories.map((category, index) => {
//                         const isHovered = hoveredCategory === category.super_cat_id;
//                         return (
//                             <div key={index} style={{ position: 'relative' }} onMouseEnter={() => setHoveredCategory(category.super_cat_id)} onMouseLeave={() => { setHoveredCategory(null); setHoveredSubcat(null); }}>
//                                 <Link to={`/category/${encodeURIComponent(category.super_cat_name)}`} style={{ fontSize: '14px', color: category.super_cat_name === categoryName ? '#d32f2f' : '#333', fontWeight: category.super_cat_name === categoryName ? 'bold' : 'normal', cursor: 'pointer', textDecoration: 'none', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '4px', }}>
//                                     {category.super_cat_name}
//                                     <FaCaretDown />
//                                 </Link>
//                                 {Array.isArray(category.subs) && category.subs.length > 0 && (
//                                     <div style={{ display: isHovered ? 'block' : 'none', position: 'absolute', top: '100%', left: 0, backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', padding: '10px', zIndex: 1000, minWidth: '200px', }}>
//                                         {category.subs.map((sub, i) => {
//                                             const subSubs = getSubcategoriesForCategory(sub.id, category.super_cat_id);
//                                             const isSubHovered = hoveredSubcat === sub.id;
//                                             return (
//                                                 <div key={i} onMouseEnter={() => setHoveredSubcat(sub.id)} onMouseLeave={() => setHoveredSubcat(null)} style={{ position: 'relative' }}>
//                                                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 10px', fontSize: '13px', color: '#333', cursor: 'pointer', whiteSpace: 'nowrap', }}>
//                                                         <Link to={`/food/${encodeURIComponent(sub.name)}`} style={{ color: '#333', textDecoration: 'none', flexGrow: 1, }} onClick={(e) => e.stopPropagation()} >
//                                                             {sub.name}
//                                                         </Link>
//                                                         {Array.isArray(subSubs) && subSubs.length > 0 && <IoMdArrowDropright />}
//                                                     </div>
//                                                     {Array.isArray(subSubs) && subSubs.length > 0 && (
//                                                         <div style={{ display: isSubHovered ? 'block' : 'none', position: 'absolute', top: 0, left: '100%', backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', padding: '10px', zIndex: 1000, minWidth: '180px', }}>
//                                                             {subSubs.map((s, idx) => (
//                                                                 <Link to={`/food/${encodeURIComponent(s.subCategory)}`} key={idx} style={{ display: 'block', padding: '6px 10px', color: '#333', textDecoration: 'none', fontSize: '13px', whiteSpace: 'nowrap', }}>
//                                                                     {s.subCategory}
//                                                                 </Link>
//                                                             ))}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             );
//                                         })}
//                                     </div>
//                                 )}
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>






//             {showLoginModal && (
//                 <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                     <div style={{ width: '90%', maxWidth: '600px', backgroundColor: '#fff', borderRadius: '12px', display: 'flex', overflow: 'hidden' }}>
//                         <div style={{ background: '#f4f4f4', flex: 1, padding: '25px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center' }}>
//                             <h4 style={{ color: '#858585', fontWeight: 600, fontSize: '14px' }}>Why choose shreenath foods?</h4>
//                             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginTop: '20px' }}>
//                                 {[
//                                     ['Quality', 'https://img.icons8.com/ios/50/checkmark--v1.png'],
//                                     ['On time', 'https://img.icons8.com/ios/50/clock--v1.png'],
//                                     ['Return Policy', 'https://img.icons8.com/ios/50/return.png'],
//                                     ['Free Delivery', 'https://img.icons8.com/ios/50/delivery.png']
//                                 ].map(([label, icon], index) => (
//                                     <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                                         <img src={icon} alt={label} style={{ width: '30px', height: '30px' }} />
//                                         <span style={{ fontSize: '12px', marginTop: '8px', color: '#333' }}>{label}</span>
//                                     </div>
//                                 ))}
//                             </div>
//                             <hr style={{ margin: '20px 0', borderColor: '#ccc' }} />
//                             <div>
//                                 <p style={{ fontSize: '12px', color: '#555' }}>Find us on</p>
//                                 <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px' }}>
//                                     <img src={A1} alt="Play Store" style={{ height: '30px' }} />
//                                     <img src={A2} alt="App Store" style={{ height: '30px' }} />
//                                 </div>
//                             </div>
//                         </div>


//                         <>
//                             <div style={{ background: '#000', color: '#fff', flex: 1, padding: '30px', position: 'relative' }}>
//                                 <button onClick={() => setShowLoginModal(false)} style={{ position: 'absolute', top: '10px', right: '15px', fontSize: '18px', background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer' }}>✖</button>

//                                 {step === 'login' && (
//                                     <>
//                                         <h2 style={{ fontSize: '22px', marginBottom: '8px' }}>Login/ Sign up</h2>
//                                         <p style={{ color: '#f8c200', fontSize: '12px', marginBottom: '20px' }}>Using OTP</p>
//                                         <input type="text" placeholder="Enter Mobile Number or Email" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: 'none', outline: 'none', marginBottom: '20px' }} />
//                                         <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
//                                             onClick={() => {
//                                                 const phoneRegex = /^[6-9]\d{9}$/;
//                                                 const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//                                                 if (!phoneRegex.test(mobileNumber) && !emailRegex.test(mobileNumber)) {
//                                                     return alert("Please enter a valid mobile number or email address");
//                                                 }

//                                                 sendOtp();
//                                             }}>
//                                             Continue
//                                         </button>
//                                     </>
//                                 )}
//                                 {step === 'otp' && (
//                                     <>
//                                         <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Verify Mobile Number</h2>
//                                         <p style={{ fontSize: '14px', color: '#ccc', marginBottom: '10px' }}>+91 {mobileNumber} ✎</p>
//                                         <p style={{ fontSize: '14px', marginBottom: '10px' }}>Enter OTP</p>
//                                         <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//                                             {otp.map((digit, idx) => (
//                                                 <input key={idx} id={`otp-${idx}`} type="text" maxLength="1" value={digit}
//                                                     onChange={(e) => {
//                                                         const newOtp = [...otp]; newOtp[idx] = e.target.value; setOtp(newOtp);
//                                                         if (e.target.value && idx < 5) document.getElementById(`otp-${idx + 1}`)?.focus();
//                                                     }} style={{ width: '40px', height: '40px', textAlign: 'center', fontSize: '18px', borderRadius: '6px', border: '1px solid #ccc' }}
//                                                 />
//                                             ))}
//                                         </div>
//                                         <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
//                                             onClick={() => { const enteredOtp = otp.join(''); if (enteredOtp.length !== 6) return alert('Please enter 6-digit OTP'); verifyOtp(); }}>
//                                             Verify & Continue
//                                         </button>
//                                         <p style={{ marginTop: '15px', color: '#ccc', fontSize: '12px' }}>Resend OTP in 00:{timer < 10 ? `0${timer}` : timer}</p>
//                                     </>
//                                 )}
//                                 {step === 'userinfo' && (
//                                     <>
//                                         <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Tell us about you</h2>
//                                         <input type="text" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <input type="text" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <select value={businessType} onChange={(e) => setBusinessType(e.target.value)}
//                                             style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }}>
//                                             <option value="">Select Business Type</option>
//                                             <option value="B2B">B2B</option>
//                                             <option value="B2C">B2C</option>
//                                         </select>
//                                         <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
//                                             onClick={() => {
//                                                 if (!firstName || !lastName || !email) return alert("Please fill all fields");
//                                                 updateUserInfo();
//                                             }}>
//                                             Continue
//                                         </button>
//                                     </>
//                                 )}
//                                 {step === 'address' && (
//                                     <>
//                                         <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Add Delivery Address</h2>
//                                         <input type="text" placeholder="Address Line 1" value={address.line1} onChange={(e) => setAddress({ ...address, line1: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <input type="text" placeholder="Address Line 2" value={address.line2} onChange={(e) => setAddress({ ...address, line2: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <input type="text" placeholder="City" value={address.city} onChange={(e) => setAddress({ ...address, city: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <input type="text" placeholder="State" value={address.state} onChange={(e) => setAddress({ ...address, state: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <input type="text" placeholder="Pincode" value={address.zip} maxLength={6} onChange={(e) => setAddress({ ...address, zip: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
//                                         <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
//                                             onClick={() => {
//                                                 if (!address.line1 || !address.city || !address.state || !address.zip) {
//                                                     return alert("Please complete your address");
//                                                 }
//                                                 saveAddress();
//                                             }}
//                                         >
//                                             Finish & Save
//                                         </button>
//                                     </>
//                                 )}



//                                 <p style={{ fontSize: '10px', marginTop: '15px', color: '#ccc' }}>
//                                     By continuing, I accept TCP - <a href="/terms-of-service" style={{ color: '#ccc', textDecoration: 'underline' }}>Terms</a> and <a href="/privacy-policy" style={{ color: '#ccc', textDecoration: 'underline' }}>Privacy Policy</a>.
//                                 </p>
//                             </div>
//                         </>
//                     </div>
//                 </div>
//             )}

//         </>
//     );
// };

// export default Header;







import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FaUser, FaShoppingBag, FaSearch, FaBars, FaTimes, FaArrowLeft } from "react-icons/fa";
import "./Header.css";
import logo from './logo1.jpeg';
import { CartContext } from '../Cart/CartContext';
import { WishlistContext } from '../Wishlist/WishlistContext';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import A1 from './google.png'
import A2 from './appstore.png'
import { useRef } from 'react';
import { FaCaretDown } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import SearchBar from "./SearchBar";
import { FaFacebookF, FaTwitter, FaGoogle, FaInstagram, FaWhatsapp } from 'react-icons/fa';



const Header = ({ isMobile }) => {
 const iconSize = 18; // smaller size
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { cartItems } = useContext(CartContext);
    const { wishlistItems } = useContext(WishlistContext);
    const [categoriesp, setCategoriesp] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const { categoryName } = useParams();
    const [hoveredSubcat, setHoveredSubcat] = useState(null);



    const [wishlist, setWishlist] = useState({}); // mapping key -> true
    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('userData'));
        if (!user?.id) return;
        axios
            .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
            .then((res) => {
                // const wishMap = {}; 
                // res.data.forEach((item) => {
                //   const key = `${item.productId}_${item.variantId}`;
                //   wishMap[key] = true;
                // });
                setWishlist(res.data);
            })
            .catch((err) => console.error('Error fetching wishlist:', err));
    }, []);

    console.log('this is wishlist11', wishlist)

    const [productss, setProductss] = useState([]); // All products
    const [enrichedWishlist, setEnrichedWishlist] = useState([]);

    const user = JSON.parse(sessionStorage.getItem('userData'));
    const userId1 = user?.id;
    const customerType = user?.businessType;

    // Fetch all productss
    useEffect(() => {
        axios
            .get('https://api.glocart.in/pages/api/products/get')
            .then((res) => {
                const updated = res.data.map((p) => {
                    const bestVariant = p.variants?.reduce(
                        (best, v) => (v.discount > best.discount ? v : best),
                        p.variants[0]
                    );
                    return { ...p, selectedVariant: bestVariant };
                });
                setProductss(updated);
            })
            .catch((err) => console.error('Error fetching productss:', err));
    }, []);

    // Merge wishlist items with productss
    useEffect(() => {
        if (userId1 && productss.length > 0 && wishlist) {
            // For logged-in user
            const merged = Object.values(wishlist)
                .map((wishItem) => {
                    console.log('this is wishItem', wishItem)
                    console.log('this is productss', productss)
                    const product = productss.find((p) => p.id === wishItem.productId);
                    console.log('this is product', product)
                    if (!product) return null;
                    const variant = product.variants?.find((v) => v.id === wishItem.variantId) || product.selectedVariant;
                    return { ...product, ...wishItem, variant };
                })
                .filter(Boolean); // Remove nulls
            console.log('this is merged', merged)
            setEnrichedWishlist(merged);
        } else if (!userId1) {
            // Guest user: use wishlistItems directly
            setEnrichedWishlist(wishlistItems);
        }
    }, [userId1, wishlist, wishlistItems, productss]);

    const displayList = enrichedWishlist;




    // Helper to save guest wishlist to localStorage
    const saveWishlistToLocalStorage = (list) => {
        localStorage.setItem('wishlistItems', JSON.stringify(list));
    };


    // Fetch categories and subcategories safely
    useEffect(() => {
        fetch('https://api.glocart.in/pages/api/api/categories')
            .then(res => res.json())
            .then(data => {
                // Ensure we only store an array
                const categoriesArray = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
                setCategoriesp(categoriesArray);
            })
            .catch(err => console.error('Error fetching categories:', err));

        fetch('https://api.glocart.in/pages/api/api/subcategories')
            .then(res => res.json())
            .then(data => {
                const subcatsArray = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
                setSubcategories(subcatsArray);
            })
            .catch(err => console.error('Error fetching subcategories:', err));
    }, []);

    console.log('this is categoriesp', categoriesp)

    // Group categories by super_cat_id safely
    const groupedCategories = Array.isArray(categoriesp)
        ? Object.values(
            categoriesp.reduce((acc, item) => {
                if (!acc[item.super_cat_id]) {
                    acc[item.super_cat_id] = {
                        super_cat_id: item.super_cat_id,
                        super_cat_name: item.super_cat_name,
                        subs: [],
                    };
                }
                acc[item.super_cat_id].subs.push(item);
                return acc;
            }, {})
        )
        : [];

    // Get subcategories for a specific category safely
    const getSubcategoriesForCategory = (category_id, super_cat_id) => {
        return Array.isArray(subcategories)
            ? subcategories.filter(
                sub =>
                    sub.category_id === String(category_id) &&
                    sub.super_cat_id === String(super_cat_id)
            )
            : [];
    };













    const getCartItemCount = () => cartItems.reduce((total, item) => total + item.quantity, 0);


    const [products, setProducts] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const wrapperRef = useRef(null);
    useEffect(() => {
        axios.get('https://api.glocart.in/pages/api/products/get')
            .then(res => {
                const data = res.data;
                // adjust depending on API shape
                const list = Array.isArray(data) ? data : (data.products || []);
                setProducts(list);
            })
            .catch(err => console.error('Error fetching products for search:', err));
    }, []);
    const onChangeSearch = (e) => {
        const val = e.target.value;
        setSearchQuery(val);

        if (val.length > 0) {
            const filtered = products.filter(prod =>
                prod.name.toLowerCase().includes(val.toLowerCase()) ||
                prod.category.toLowerCase().includes(val.toLowerCase()) ||
                (prod.subcategory && prod.subcategory.toLowerCase().includes(val.toLowerCase()))
            );
            setSuggestions(filtered.slice(0, 5));
            setShowSuggestions(true);
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };

    const onSuggestionClick = (prod) => {
        // You may navigate to product page or set input value
        navigate(`/product/${prod.id}`);
        setSearchQuery('');  // clear or set as needed
        setShowSuggestions(false);
    };

    // Close suggestions when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);














    const [isLoggedIn, setIsLoggedIn] = useState(false);
    useEffect(() => {
        const storedUserData = sessionStorage.getItem('userData');
        const storedUserId = sessionStorage.getItem('userId');
        if (storedUserData) {
            setIsLoggedIn(true);
        } else if (storedUserId) {
            resumeRegistration(storedUserId);
        }
    }, []);

    const resumeRegistration = async (id) => {
        try {
            const res = await axios.get(`https://api.glocart.in/auth/api/api/user/${id}/details`);
            const user = res.data.user;
            setUserId(user.id);

            if (!user.email || !user.addresses || user.addresses.length === 0) {
                setShowLoginModal(true);
                if (!user.email) {
                    setStep('userinfo');
                } else {
                    setEmail(user.email);
                    setStep('address');
                }
            } else {
                const loginData = {
                    id: user.id,
                    email: user.email,
                    business_type: user.business_type
                };
                sessionStorage.setItem('userData', JSON.stringify(loginData));
                setIsLoggedIn(true);

                // ✅ Sync tempCart to DB if exists
                const tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
                if (tempCart.length > 0) {
                    for (const item of tempCart) {
                        await axios.post('https://api.glocart.in/pages/api/api/add-to-cart', {
                            userId: loginData.id,
                            productId: item.productId,
                            variantId: item.variantId,
                            quantity: item.quantity,
                            customerType: item.type || (loginData.business_type === 'B2B' ? 'B2B' : 'B2C'),
                        });
                    }
                    sessionStorage.removeItem('tempCart');
                }
            }
        } catch (err) {
            console.error('Failed to resume user registration', err);
        }
    };

    const [userId, setUserId] = useState(null);
    const [step, setStep] = useState('login');
    const [mobileNumber, setMobileNumber] = useState('');
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [timer, setTimer] = useState(30);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [businessType, setBusinessType] = useState('');
    const [address, setAddress] = useState({ line1: '', line2: '', city: '', state: '', zip: '', });
    const resetForm = () => {
        setStep('login');
        setMobileNumber('');
        setOtp(['', '', '', '', '', '']);
        setFirstName('');
        setLastName('');
        setEmail('');
        setAddress({ line1: '', line2: '', city: '', state: '', zip: '', });
        setUserId(null);
    };

    useEffect(() => {
        if (step === 'otp' && timer > 0) {
            const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
            return () => clearInterval(interval);
        }
    }, [step, timer]);

    const sendOtp = async () => {
        try {
            await axios.post('https://api.glocart.in/auth/api/api/send-otp', { contact: mobileNumber });
            setStep('otp'); setTimer(30);
        } catch (error) {
            console.error(error);
            alert(error.response?.data?.error || 'Failed to send OTP');
        }
    };

    // 2. Verify OTP
    const verifyOtp = async () => {
        try {
            const enteredOtp = otp.join('');
            const res = await axios.post('https://api.glocart.in/auth/api/api/verify-otp', {
                contact: mobileNumber,
                otp: enteredOtp
            });
            if (res.data.success) {
                const userId = res.data.userId;
                setUserId(userId);
                sessionStorage.setItem('userId', userId);
                const userRes = await axios.get(`https://api.glocart.in/auth/api/api/user/${userId}/details`);
                const user = userRes.data.user;
                if (user.email && user.addresses && user.addresses.length > 0) {
                    const loginData = {
                        id: user.id,
                        email: user.email,
                        business_type: user.business_type
                    };
                    sessionStorage.setItem('userData', JSON.stringify(loginData));
                    //wishlist 
                    const wishlistItems = JSON.parse(localStorage.getItem('wishlistItems')) || [];
                    for (const item of wishlistItems) {
                        console.log(item)
                        await axios.post('https://api.glocart.in/pages/api/app/add-to-wishlist', {
                            userId: loginData.id,
                            productId: item.id,
                            variantId: item.variant,
                            // quantity: item.quantity,
                            customerType: item.type || (userId?.businessType === 'B2B' ? 'B2B' : 'B2C'),
                        });
                    };



                    //cart
                    const tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
                    console.log(tempCart)
                    for (const item of tempCart) {
                        console.log(item)
                        await axios.post('https://api.glocart.in/pages/api/api/add-to-cart', {
                            userId: loginData.id,
                            productId: item.productId,
                            variantId: item.variantId,
                            quantity: item.quantity,
                            customerType: item.type || (userId?.businessType === 'B2B' ? 'B2B' : 'B2C'),
                        });
                    };
                    sessionStorage.removeItem('tempCart');
                    localStorage.removeItem('wishlistItems');
                    setIsLoggedIn(true);
                    setShowLoginModal(false);
                    resetForm();
                    navigate('/cart');
                } else {
                    setStep('userinfo');
                }
            } else {
                alert(res.data.error || 'Invalid or expired OTP');
            }
        } catch (error) {
            console.error(error);
            alert('OTP verification failed');
        }
    };


    // 3. Update user info
    const updateUserInfo = async () => {
        try {
            await axios.post('https://api.glocart.in/auth/api/api/update-user', { userId, first_name: firstName, last_name: lastName, email, business_type: businessType, });
            const loginData = {
                id: userId,
                email,
                business_type: businessType
            };
            sessionStorage.setItem('userData', JSON.stringify(loginData));

            setStep('address');
        } catch (err) {
            console.error(err); alert('Failed to update user');
        }
    };



    // 4. Save address
    const saveAddress = async () => {
        try {
            await axios.post('https://api.glocart.in/auth/api/api/save-address', {
                userId,
                address
            });

            const loginData = JSON.parse(sessionStorage.getItem('userData'));

            // ✅ Sync tempCart to DB after full registration
            const tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
            for (const item of tempCart) {
                await axios.post('https://api.glocart.in/pages/api/api/add-to-cart', {
                    userId: loginData.id,
                    productId: item.productId,
                    variantId: item.variantId,
                    quantity: item.quantity,
                    customerType: item.type || (loginData.business_type === 'B2B' ? 'B2B' : 'B2C'),
                });
            }

            // ✅ Now remove tempCart and proceed
            sessionStorage.removeItem('tempCart');
            alert('Account created!');
            setIsLoggedIn(true);
            setShowLoginModal(false);
            resetForm();
            if (tempCart.length > 0) {
                navigate('/cart');
            } else {
                navigate('/');
            }
        } catch (err) {
            console.error(err);
            alert('Failed to save address');
        }
    };



    const logout = () => {
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('userId');
        setIsLoggedIn(false);
        resetForm();
        setShowUserMenu(false);
        console.log("Logged out, session data cleared");
    };

    const [showUserMenu, setShowUserMenu] = useState(false);
    const toggleUserMenu = () => { setShowUserMenu(prev => !prev); };
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.user-menu-container')) {
                setShowUserMenu(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);



    const navigate = useNavigate();
    const handleCartClick = () => {
        if (isLoggedIn) {
            navigate('/cart');
        } else {
            setShowLoginModal(true);
        }
    };



















    const [userLocation, setUserLocation] = useState(null);
    const [showLocationModal, setShowLocationModal] = useState(false);
    const [markerPosition, setMarkerPosition] = useState({
        lat: 28.6139,
        lng: 77.2090,
    });
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    });
    const handleLocationClick = () => setShowLocationModal(true);
    const onMarkerDragEnd = useCallback((e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setMarkerPosition({ lat, lng });
        reverseGeocode(lat, lng);
    }, []);
    const reverseGeocode = async (lat, lng) => {
        try {
            const API_KEY = "AIzaSyAskOLVxenXFbWP4Z-kTOJnzaC-p7a5fBM";
            const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
            );
            const data = await res.json();
            if (data.results[0]) {
                setUserLocation(data.results[0].formatted_address);
            }
        } catch (err) {
            console.error("Geocoding error:", err);
        }
    };
    const getCurrentLocation = () => {
        if (!navigator.geolocation) return alert("Geolocation not supported");
        navigator.geolocation.getCurrentPosition((pos) => {
            const { latitude, longitude } = pos.coords;
            setMarkerPosition({ lat: latitude, lng: longitude });
            reverseGeocode(latitude, longitude);
        });
    };
    const truncateAddress = (address) =>
        address.length > 40 ? address.slice(0, 40) + "..." : address;




    // const [menuOpen, setMenuOpen] = useState(false);

    // const toggleMenu = () => setMenuOpen(!menuOpen);

    // varma changes start here


    const [menuOpen, setMenuOpen] = useState(false);
    // const [categoriesp, setCategoriesp] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCategory1, setSelectedCategory1] = useState(null);
    const [subCategories, setSubCategories] = useState([]);

    // // Fetch categories from the API
    // useEffect(() => {
    //     fetch("https://api.glocart.in/pages/api/api/categories")
    //         .then(res => res.json())
    //         .then(data => setCategoriesp(data))
    //         .catch(err => console.error("Error fetching categories:", err));
    // }, []);

    // Toggle menu open/close
    const toggleMenu = () => setMenuOpen(!menuOpen);
    console.log('this is subcategories', subcategories)
    // Handle category click to show subcategories
    const handleCategoryClick1 = (categoryId) => {
        // Find subcategories for the selected category
        const filteredSubCategories = categoriesp.filter(
            (category) => category.super_cat_id === categoryId
        );
        setSelectedCategory(categoryId);
        setSubCategories(filteredSubCategories);
    };


    // Handle category click to show subcategories
    const handleCategoryClick = (categoryId, category) => {
        const categoryIdStr = categoryId.toString();


        const filteredSubCategories = subcategories.filter(
            (subCategory) => subCategory.category_id === categoryIdStr
        );
        console.log('this is filteredSubCategories', filteredSubCategories)
        setSelectedCategory(categoryId);
        setSelectedCategory1(category);
        setSubCategories(filteredSubCategories);
    };

    console.log('this is selectedCategory', selectedCategory)

    console.log('this is subCategories', subCategories)

    // Handle back button click to go back to categories
    const handleBackClick = () => {
        setSelectedCategory(null);
        setSubCategories([]);
    };


    // Function to handle navigation
    const handleNavigate = (path) => {
        navigate(path);
        window.location.reload();
    };


    const handleCuisine = (extraParam) => {

        let path = `/categories/${encodeURIComponent(extraParam)}`;

        navigate(path);
        window.location.reload();
    };

    return (
        <header className="header">

            {/* 🔹 Top Offer Banner */}
            {/* <div className="top-banner">“Download the app to get ₹275 off first order” -  customer care number - 9703933115.</div> */}

<div  style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 20px',
      backgroundColor: '#0357a0',
      fontSize: '14px',
      flexWrap: 'wrap',
      color:'white',
    }}>
           <div style={{
        display: 'flex',
        gap: '12px',
        justifyContent: isMobile ? 'center' : 'flex-end',
         width: isMobile ? '100%' : 'auto',
        // flex: '0 0 auto',
        color:'white'
      }}>
        <a href="https://www.facebook.com/shreenathfoods" target="_blank" rel="noopener noreferrer">
          <FaFacebookF size={iconSize} style={{ cursor: 'pointer' , color:'white' }} />
        </a>
        <a href="https://twitter.com/shreenathfoods" target="_blank" rel="noopener noreferrer">
          <FaTwitter size={iconSize} style={{ cursor: 'pointer' , color:'white'}} />
        </a>
        <a href="https://www.google.com/search?q=Shreenath+Foods" target="_blank" rel="noopener noreferrer">
          <FaGoogle size={iconSize} style={{ cursor: 'pointer', color:'white' }} />
        </a>
        <a href="https://www.instagram.com/glocart.in?igsh=MTV1dHhvaXQ5MnFp" target="_blank" rel="noopener noreferrer">
          <FaInstagram size={iconSize} style={{ cursor: 'pointer', color:'white' }} />
        </a>
        <a href="https://wa.me/9703933115" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp size={iconSize} style={{ cursor: 'pointer', color: '#25D366' }} />
        </a>
      </div>
      {/* LEFT SIDE TEXT */}
      <div className='top-banner' style={{ textAlign: 'right', flex: 1 }}>
        “Download the app to get ₹275 off first order” - customer care number - 9703933115
      </div>

      {/* RIGHT SIDE SOCIAL ICONS */}
      {/* <div style={{
        display: 'flex',
        gap: '12px',
        justifyContent: isMobile ? 'center' : 'flex-end',
         width: isMobile ? '100%' : 'auto',
        // flex: '0 0 auto',
        color:'white'
      }}>
        <a href="https://www.facebook.com/shreenathfoods" target="_blank" rel="noopener noreferrer">
          <FaFacebookF size={iconSize} style={{ cursor: 'pointer' }} />
        </a>
        <a href="https://twitter.com/shreenathfoods" target="_blank" rel="noopener noreferrer">
          <FaTwitter size={iconSize} style={{ cursor: 'pointer' }} />
        </a>
        <a href="https://www.google.com/search?q=Shreenath+Foods" target="_blank" rel="noopener noreferrer">
          <FaGoogle size={iconSize} style={{ cursor: 'pointer' }} />
        </a>
        <a href="https://www.instagram.com/shreenathfoods" target="_blank" rel="noopener noreferrer">
          <FaInstagram size={iconSize} style={{ cursor: 'pointer' }} />
        </a>
        <a href="https://wa.me/919703933115" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp size={iconSize} style={{ cursor: 'pointer', color: '#25D366' }} />
        </a>
      </div> */}
    </div>

            {/* 🔹 Main Header Section */}
            <div className="containerr">
                <div className="header-main">
                    {/* Hamburger for Mobile */}
                    <div className="menu-icon" onClick={toggleMenu}><FaBars /></div>
                    {/* Logo */}
                    <div className="logo"><a href='/'><img src={logo} alt="Glow Cart Logo" /></a></div>
                    {/* Desktop Search Bar */}
                    {/* <div className="search-bar">
                        <FaSearch className="search-icon" />
                        <input type="text" placeholder="Search for ingredients, products..." />
                    </div> */}
                    <div className="search-bar">
                        <SearchBar products={productss} />
                    </div>

                    {/* Icons */}
                    <div className="header-icons">
                        {isLoggedIn ? (
                            <div className="user-menu-container" style={{ position: 'relative' }}>
                                <FaUser onClick={toggleUserMenu} style={{ fontSize: '22px', color: '#000', cursor: 'pointer' }} />
                                {showUserMenu && (
                                    <div style={{ position: 'absolute', top: '35px', right: 0, background: '#1c1c1c', color: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.2)', width: '280px', zIndex: 1000, padding: '10px 0', }}>
                                        <div style={{ padding: '10px 16px', cursor: 'pointer' }}>
                                            <Link to="/account" style={{ color: 'inherit', textDecoration: 'none' }}>My Account</Link>
                                        </div>
                                        <div style={{ padding: '10px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Link to="/cart" style={{ color: 'inherit', textDecoration: 'none', flex: 1 }}>My Basket</Link>
                                            <span style={{ backgroundColor: 'red', borderRadius: '12px', padding: '2px 8px', fontSize: '12px' }}>{getCartItemCount()}</span>
                                        </div>
                                        <div style={{ padding: '10px 16px', cursor: 'pointer' }}>
                                            <Link to="/orders" style={{ color: 'inherit', textDecoration: 'none' }}>My Orderss</Link>
                                        </div>
                                        <div style={{ padding: '10px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Link to="/wishlist" style={{ color: 'inherit', textDecoration: 'none' }}>Wishlist</Link>
                                            <span style={{ backgroundColor: 'red', borderRadius: '12px', padding: '2px 8px', fontSize: '12px' }}>{displayList.length}</span>
                                        </div>
                                        <div style={{ padding: '10px 16px', cursor: 'pointer' }}>
                                            <Link to="/contact-us" style={{ color: 'inherit', textDecoration: 'none' }}>Contact Us</Link>
                                        </div>
                                        <div style={{ padding: '10px 16px', cursor: 'pointer', color: '#ff5252' }} onClick={logout}>
                                            Logout
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <FaUser onClick={() => setShowLoginModal(true)} className="icon" />
                        )}
                        <div onClick={handleCartClick} style={{ position: 'relative', marginLeft: '10px', cursor: 'pointer' }}>
                            <FaShoppingBag className="icon" />
                            <span style={{ position: 'absolute', top: '-6px', right: '-10px', background: 'red', color: 'white', fontSize: '11px', padding: '2px 6px', borderRadius: '50%' }}>
                                {getCartItemCount()}
                            </span>
                        </div>
                    </div>
                </div>

                {/* 🔹 Search for Mobile / Tablet */}
                <div className="search-bar-mobile">
                    {/* <FaSearch className="search-icon" />
                    <input type="text" placeholder="Search for ingredients, products..." /> */}
                    <SearchBar products={productss} />
                </div>




                {/* 🔹 Categories Menu */}
                <div className="category-menu" onMouseLeave={() => setHoveredCategory(null)}>
                    <ul>
                        {categoriesp.map((category) => (
                            <li key={category.id} style={{fontSize:'13px'}} className="category-item" onMouseEnter={() => setHoveredCategory(category.id)}>
                                {category.name} <FaCaretDown className="dropdown-icon" />
                            </li>
                        ))}
                    </ul>
                    {hoveredCategory && (
                        <div className="subcategory-dropdown">
                            {subcategories
                                .filter(sub => sub.category_id === String(hoveredCategory))
                                .map(sub => (
                                    // <Link key={sub.id} to={`/food/${sub.category_name}/${sub.subCategory}`} className="subcategory-item">
                                    //     <img src={sub.image_sub} alt={sub.subCategory} />
                                    //     <span>{sub.subCategory}</span>
                                    // </Link>
                                    <div
                                        key={sub.id}
                                        className="subcategory-item"
                                        onClick={() => handleNavigate(`/food/${sub.category_name}/${sub.subCategory}`)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <img src={sub.image_sub} alt={sub.subCategory} />
                                        <span>{sub.subCategory}</span>
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>





            </div>


            {/* 🔹 Sidebar for Mobile */}
            {/* <div className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
                <div className="close-icon" onClick={toggleMenu}>
                    <FaTimes />
                </div>

                <ul >
                    {[...new Set(categoriesp.map(cat => cat.name))].map((category, index) => (
                        <li key={index}>     <div onClick={() => handleCuisine(category)}> {category}   </div></li>
                    ))}
                </ul>

            </div> */}

            {/* 🔹 Overlay when Sidebar Open */}
            {/* {menuOpen && <div className="overlay" onClick={toggleMenu}></div>} */}



            <div>
                {/* Mobile Sidebar */}
                <div className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
                    <div className="close-icon" onClick={toggleMenu}>
                        <FaTimes />
                    </div>

                    {/* If selectedCategory is null, show categories */}
                    {!selectedCategory ? (
                        <ul>
                            {categoriesp.map((category) => (
                                <li key={category.id} onClick={() => handleCategoryClick(category.id, category)}>
                                    <div className="category-item">
                                        <img
                                            src={category.image}
                                            alt={category.name}
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                marginRight: "10px",
                                                borderRadius: "5px",
                                            }}
                                        />
                                        {category.name}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        // Show subcategories when a category is selected
                        <div>
                            <button className="back-button" onClick={handleBackClick}>
                                <FaArrowLeft /> Back to Categories
                            </button>
                            <ul>
                                {subCategories
                                    // .filter((subCategory) => subCategory.category_id === selectedCategory) 
                                    .map((subCategory) => (
                                        <li key={subCategory.id}>

                                            <div
                                                onClick={() => {
                                                    setMenuOpen(false);
                                                    navigate(`/food/${encodeURIComponent(selectedCategory1.name)}/${encodeURIComponent(subCategory.subCategory)}`);
                                                    window.location.reload();
                                                }}

                                            >
                                                <div className="category-item1">
                                                    <img
                                                        src={subCategory.image_sub}
                                                        alt={subCategory.image_sub}
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            marginRight: "10px",
                                                            borderRadius: "5px",
                                                        }}
                                                    />
                                                    {subCategory.subCategory}
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Overlay when Sidebar Open */}
                {menuOpen && <div className="overlay" onClick={toggleMenu}></div>}


            </div>


















            {showLoginModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '90%', maxWidth: '600px', backgroundColor: '#fff', borderRadius: '12px', display: 'flex', overflow: 'hidden' }}>
                        <div style={{ background: '#f4f4f4', flex: 1, padding: '25px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center', }}>
                            <h4 style={{ color: '#858585', fontWeight: 600, fontSize: '14px', }} >Why choose GloCart ?</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginTop: '20px', gridTemplateColumnsLg: 'repeat(4, 1fr)', gridTemplateColumnsMd: 'repeat(2, 1fr)', gridTemplateColumnsSm: 'repeat(1, 1fr)', }} >
                                {[
                                    ['Quality', 'https://img.icons8.com/ios/50/checkmark--v1.png'],
                                    ['On time', 'https://img.icons8.com/ios/50/clock--v1.png'],
                                    ['Return Policy', 'https://img.icons8.com/ios/50/return.png'],
                                    ['Free Delivery', 'https://img.icons8.com/ios/50/delivery.png'],
                                ].map(([label, icon], index) => (
                                    <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                        <img src={icon} alt={label} style={{ width: '30px', height: '30px', }} />
                                        <span style={{ fontSize: '12px', marginTop: '8px', color: '#333', }}>{label}</span>
                                    </div>
                                ))}
                            </div>
                            <hr style={{ margin: '20px 0', borderColor: '#ccc' }} />
                            <div>
                                <p style={{ fontSize: '12px', color: '#555' }}>Find us on</p>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px', flexWrap: 'wrap', }}>
                                    <img src={A1} alt="Play Store" style={{ height: '30px' }} />
                                    <img src={A2} alt="App Store" style={{ height: '30px' }} />
                                </div>
                            </div>
                        </div>
                        <>
                            <div style={{ background: '#000', color: '#fff', flex: 1, padding: '30px', position: 'relative' }}>
                                <button onClick={() => setShowLoginModal(false)} style={{ position: 'absolute', top: '10px', right: '15px', fontSize: '18px', background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer' }}>✖</button>
                                {step === 'login' && (
                                    <>
                                        <h2 style={{ fontSize: '22px', marginBottom: '8px' }}>Login/ Sign up</h2>
                                        <p style={{ color: '#f8c200', fontSize: '12px', marginBottom: '20px' }}>Using OTP</p>
                                        <input type="text" placeholder="Enter Mobile Number or Email" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: 'none', outline: 'none', marginBottom: '20px' }} />
                                        <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
                                            onClick={() => {
                                                const phoneRegex = /^[6-9]\d{9}$/;
                                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                if (!phoneRegex.test(mobileNumber) && !emailRegex.test(mobileNumber)) {
                                                    return alert("Please enter a valid mobile number or email address");
                                                }

                                                sendOtp();
                                            }}>
                                            Continue
                                        </button>
                                    </>
                                )}
                                {step === 'otp' && (
                                    <>
                                        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Verify Mobile Number</h2>
                                        <p style={{ fontSize: '14px', color: '#ccc', marginBottom: '10px' }}>+91 {mobileNumber} ✎</p>
                                        <p style={{ fontSize: '14px', marginBottom: '10px' }}>Enter OTP</p>
                                        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                                            {otp.map((digit, idx) => (
                                                <input key={idx} id={`otp-${idx}`} type="text" maxLength="1" value={digit}
                                                    onChange={(e) => {
                                                        const newOtp = [...otp]; newOtp[idx] = e.target.value; setOtp(newOtp);
                                                        if (e.target.value && idx < 5) document.getElementById(`otp-${idx + 1}`)?.focus();
                                                    }} style={{ width: '40px', height: '40px', textAlign: 'center', fontSize: '18px', borderRadius: '6px', border: '1px solid #ccc' }}
                                                />
                                            ))}
                                        </div>
                                        <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
                                            onClick={() => { const enteredOtp = otp.join(''); if (enteredOtp.length !== 6) return alert('Please enter 6-digit OTP'); verifyOtp(); }}>
                                            Verify & Continue
                                        </button>
                                        <p style={{ marginTop: '15px', color: '#ccc', fontSize: '12px' }}>Resend OTP in 00:{timer < 10 ? `0${timer}` : timer}</p>
                                    </>
                                )}
                                {step === 'userinfo' && (
                                    <>
                                        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Tell us about you</h2>
                                        <input type="text" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <input type="text" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <select value={businessType} onChange={(e) => setBusinessType(e.target.value)}
                                            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }}>
                                            <option value="">Select Business Type</option>
                                            <option value="B2B">B2B</option>
                                            <option value="B2C">B2C</option>
                                        </select>
                                        <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
                                            onClick={() => {
                                                if (!firstName || !lastName || !email) return alert("Please fill all fields");
                                                updateUserInfo();
                                            }}>
                                            Continue
                                        </button>
                                    </>
                                )}
                                {step === 'address' && (
                                    <>
                                        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>Add Delivery Address</h2>
                                        <input type="text" placeholder="Address Line 1" value={address.line1} onChange={(e) => setAddress({ ...address, line1: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <input type="text" placeholder="Address Line 2" value={address.line2} onChange={(e) => setAddress({ ...address, line2: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <input type="text" placeholder="City" value={address.city} onChange={(e) => setAddress({ ...address, city: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <input type="text" placeholder="State" value={address.state} onChange={(e) => setAddress({ ...address, state: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <input type="text" placeholder="Pincode" value={address.zip} maxLength={6} onChange={(e) => setAddress({ ...address, zip: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }} />
                                        <button style={{ width: '100%', backgroundColor: '#b21f1f', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
                                            onClick={() => {
                                                if (!address.line1 || !address.city || !address.state || !address.zip) {
                                                    return alert("Please complete your address");
                                                }
                                                saveAddress();
                                            }}
                                        >
                                            Finish & Save
                                        </button>
                                    </>
                                )}



                                <p style={{ fontSize: '10px', marginTop: '15px', color: '#ccc' }}>
                                    By continuing, I accept TCP - <a href="/terms-of-service" style={{ color: '#ccc', textDecoration: 'underline' }}>Terms</a> and <a href="/privacy-policy" style={{ color: '#ccc', textDecoration: 'underline' }}>Privacy Policy</a>.
                                </p>
                            </div>
                        </>
                    </div>
                </div>
            )}
        </header>

    );
};

export default Header;
